import { Fragment, h } from "preact";
import { useState, useEffect } from "preact/hooks";

import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";

import ProductList from "../helpers/product-list/product-list.jsx";
import ProductFilterSort from "../helpers/filter-sort/product-filter-sort.jsx";

const filterRegex = (input) => {
  input = input.replace(/"(\w+)"\s*:/g, "$1:");
  return input;
};

const CollectionContent = ({ data }) => {
  const {
    collectionTitle,
    collectionHandle,
    perPage,
    productsCount,
    currentFilters,
    sortEnabled,
    filterEnabled,
    collectionContent,
    preselectColor,
  } = data;

  const [totalProductsCount, setTotalProductsCount] = useState(
    productsCount || 0,
  );
  const defaultSortOption = {
    key: "sort_collection_default",
    label: "Featured",
    value: "COLLECTION_DEFAULT",
    reverse: false,
  };

  const [initialLoad, setInitialLoad] = useState(false);
  const [sortOption, setSortOption] = useState(defaultSortOption);
  const [allFilters, setAllFilters] = useState([]);
  const [filters, setFilters] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterSortDrawerOpen, setfilterSortDrawerOpen] = useState("");

  useEffect(
    (event) => {
      setSelectedFilters(filters);
    },
    [filters],
  );

  const handleDrawer = (event = null, drawer, open) => {
    event && event.stopPropagation();
    drawer = event
      ? document.querySelector(`[data-${event.currentTarget.dataset.target}]`)
      : drawer;
    open = open ? open : event ? !drawer?.classList.contains("open") : false;
    document.documentElement.classList[open ? "add" : "remove"](
      "overflow-hidden",
    );

    let openClass = open ? "open" : "";
    setfilterSortDrawerOpen(
      drawer?.classList.contains("collection-drawer__toggle") ? "" : openClass,
    );
  };

  const setDefaultFilters = (filters) => {
    if (initialLoad) return;
    const newFilters = [];
    currentFilters.forEach((currentFilter) => {
      filters.forEach((filterList) => {
        if (filterList.id == currentFilter.id) {
          const selectedFilter = filterList.values.find((filter) => {
            return filter.label === currentFilter.label;
          });
          newFilters.push(selectedFilter);
        }
      });
    });
    setFilters(newFilters);
    setSelectedFilters(newFilters);
    setInitialLoad(true);
  };

  const getSelectedFacets = (filters) => {
    let facets = "";
    filters.map((filter) => {
      let facet = filterRegex(filter.input);
      facets += `${facet}`;
    });

    return facets;
  };

  const getFilters = async (facets = "") => {
    let productsQuery = `first: ${perPage}`;

    productsQuery += ", sortKey: " + `${sortOption.value}`;
    if (sortOption.reverse) {
      productsQuery += ", reverse: " + `${sortOption.reverse}`;
    }

    if (facets != "") {
      productsQuery += `,filters:[${facets}]`;
    }

    const response = await storefront.request({
      query: queries.getFilters(collectionHandle, productsQuery),
    });

    if (response?.data?.collection?.products?.filters) {
      setAllFilters(response.data.collection.products.filters);
      setDefaultFilters(response.data.collection.products.filters);
    }
  };

  const toggleFilterOption = (item, checked = true, event) => {
    let newFilters = [];
    if (checked) {
      newFilters = [...filters, item];
    } else {
      newFilters = filters.filter((object) => {
        return object.label !== item.label;
      });
    }
    setFilters(newFilters);
    applyFilterSort(event);
  };

  // Update page URL
  const updatePageUrl = (filters) => {
    if (Shopify.designMode) return;
    window.history.pushState({}, "", location.pathname);
    const url = new URL(window.location);
    filters.forEach((filter) => {
      const filterName = filter?.id?.split(".").slice(0, -1).join(".");
      url.searchParams.append(filterName, filter.label);
    });
    window.history.pushState({}, "", url);
  };

  const applyFilterSort = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedFilters(filters);
  };

  const clearAllFilters = (allFilters) => {
    setAllFilters(allFilters);
    setSelectedFilters([]);
    setFilters([]);
  };

  useEffect(() => {
    const handleClick = (e) => {
      const openedDrawer = document.querySelector(
        ".open[data-collection-drawer]",
      );
      if (openedDrawer && !openedDrawer.contains(e.target)) {
        handleDrawer(null, openedDrawer, false);
      }
    };

    const closeEsc = (e) => {
      if (e.key !== "Escape") return;

      const openedDrawer = document.querySelector(
        ".open[data-collection-drawer]",
      );
      if (openedDrawer) {
        handleDrawer(null, openedDrawer, false);
      }
    };

    document.addEventListener("keydown", closeEsc);
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("keydown", closeEsc);
    };
  }, [handleDrawer]);

  useEffect(() => {
    getFilters();
    updatePageUrl(selectedFilters);
    // animations.refresh();
  }, [selectedFilters]);

  return (
    <Fragment>
      <div className="collection__toolbar">
        <div className="collection__toolbar__inner">
          <div className="collection__toolbar__title">
            <h4 class="strong">
              <span>Shop </span>
              {collectionTitle}
            </h4>
            {(filterEnabled || sortEnabled) && (
              <span className="collection__products-count caption">
                ({totalProductsCount} products)
              </span>
            )}
          </div>
          <ProductFilterSort
            collectionHandle={collectionHandle}
            perPage={Number(perPage, 10)}
            allFilters={allFilters}
            clearAllFilters={clearAllFilters}
            applyFilterSort={applyFilterSort}
            handleDrawer={handleDrawer}
            toggleFilterOption={toggleFilterOption}
            sortOption={sortOption}
            setSortOption={setSortOption}
            totalProductsCount={totalProductsCount}
            open={filterSortDrawerOpen}
          />
        </div>
      </div>

      {initialLoad && (
        <div className="collection__products">
          <ProductList
            perPage={perPage}
            collectionHandle={collectionHandle}
            sortOption={sortOption}
            selectedFilters={selectedFilters}
            setTotalProductsCount={setTotalProductsCount}
            getSelectedFacets={getSelectedFacets}
            collectionContent={collectionContent}
            preselectColor={preselectColor}
            cardStyle="gradient"
          />
        </div>
      )}
    </Fragment>
  );
};

export default CollectionContent;
